const header = document.querySelector('.main-header');
const $ = jQuery.noConflict();
const transparentHeader = () => {
  header.classList.add('header-hero-homepage');
	if (header.classList.contains('sticky')) {
    header.classList.remove('sticky');
  }
};

function getVideoSrc() {
  let lightboxVideoSrc;
  $(".wp-block-button.is-popup .wp-block-button__link").each(function() {
    $(this).addClass("video-link");
    const buttonUrl = $(this).attr("href");

    if (buttonUrl.indexOf('youtube.com') > 0) {
      lightboxVideoSrc = getYoutubeEmbed(buttonUrl);
    } else if (buttonUrl.indexOf('vimeo.com') > 0) {
      lightboxVideoSrc = getVimeoEmbed(buttonUrl);
    }
    
    $(this).attr("data-video-src", lightboxVideoSrc);
  });
}
// Get embeded youtube video link.

function getYoutubeEmbed(url) {
  if (url.indexOf('youtube') > 0) {
      if (url.indexOf('watch') > 0) {
        const queryString = url.split('?')[1];
        const queryParams = queryString.split('=');
        let videoId = '';
        
        for (let i = 0; i < queryParams.length; i++) {
          if (queryParams[i] === 'v' && queryParams[i + 1]) {
            videoId = queryParams[i + 1];
            break;
          }
        }
        
        if (videoId !== '') {
          url = 'https://www.youtube.com/embed/' + videoId;
        }
      }
    }

    return url;
  }

// Get embeded vimeo video link.

function getVimeoEmbed(url) {
  if (url.indexOf('vimeo.com') > 0) {
      if (url.indexOf('player.vimeo.com') < 1) {
          const parsedUrl = new URL(url);
          const parsePath = parsedUrl.pathname;
          if (parsePath.includes('/')) {
            const pathSegments = parsePath.split('/');
            url = 'https://player.vimeo.com/video/' + pathSegments['1'] + "?h=" + pathSegments['2'];
            url = url
          } else {
            url = 'https://player.vimeo.com/video' + parsePath;
          }
      }
  }

  return url;
}

function fadeOnScroll(selector) {
  const element = document.querySelector(selector);
  if (!element) {
    console.error("Element not found!");
    return;
  }

  const updateOpacity = () => {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Check if the element is fully on the screen
    if (rect.bottom <= windowHeight) {
      // Calculate the opacity based on the element's position
      const opacity = Math.min(1, Math.max(0, (windowHeight - rect.top) / (rect.height + ((windowHeight / 2) - (rect.height / 2)))));

      // Apply the opacity to the element
      element.style.opacity = opacity.toFixed(2);
    } else {
      // If not fully on screen, set opacity to 0
      element.style.opacity = "0";
    }
  };

  // Initial call to set the opacity when the page loads
  updateOpacity();

  window.addEventListener("scroll", updateOpacity);
}

// GLOBAL APP CONTROLLER
const controller = {
  init() {
		transparentHeader();
    getVideoSrc();
    fadeOnScroll('.block-hero-homepage .block-hero-homepage__cta-wrapper');
  },
  loaded() {},
  resized() {},
  scrolled() {},
  keyDown() {},
  mouseUp() {},
};
export default controller;
